// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"160":"af5f7105","584":"628b5850","792":"233455f6","920":"628b5850"}[chunkId] + ".css";
};